var _namedview, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _line18, _line19, _line20, _line21, _line22, _line23, _line24, _line25, _line26, _line27, _line28, _line29, _line30, _line31, _line32, _line33, _line34, _line35, _line36, _line37, _line38, _line39, _line40, _line41, _line42, _line43, _line44, _line45, _line46, _line47, _line48, _path, _path2, _path3, _path4, _line49, _line50, _line51, _line52, _line53, _g, _g2, _g3, _g4;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgRigidBoxTemplate = function SvgRigidBoxTemplate(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "223.0mm",
    height: "223.0mm",
    viewBox: "5.400000000000006 5.400000000000006 223.0 223.0",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _namedview || (_namedview = /*#__PURE__*/React.createElement("namedview", {
    bordercolor: "#666666",
    borderopacity: 1,
    gridtolerance: 10,
    guidetolerance: 10,
    objecttolerance: 10,
    pagecolor: "#ffffff",
    showgrid: "false"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 66.9,
    x2: 166.9,
    y1: 26.900000000000006,
    y2: 26.900000000000006,
    fill: "none",
    stroke: "#000",
    strokeDasharray: "5 2 5 5 2 2",
    strokeWidth: 0.3
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 166.9,
    x2: 166.9,
    y1: 26.900000000000006,
    y2: 66.9,
    fill: "none",
    stroke: "#000",
    strokeDasharray: "5 2 5 5 2 2",
    strokeWidth: 0.3
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 66.9,
    x2: 166.9,
    y1: 66.9,
    y2: 66.9,
    fill: "none",
    stroke: "#000",
    strokeDasharray: "5 2 5 5 2 2",
    strokeWidth: 0.3
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 66.9,
    x2: 66.9,
    y1: 26.900000000000006,
    y2: 66.9,
    fill: "none",
    stroke: "#000",
    strokeDasharray: "5 2 5 5 2 2",
    strokeWidth: 0.3
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 166.9,
    x2: 206.9,
    y1: 66.9,
    y2: 66.9,
    fill: "none",
    stroke: "#000",
    strokeDasharray: "5 2 5 5 2 2",
    strokeWidth: 0.3
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 206.9,
    x2: 206.9,
    y1: 66.9,
    y2: 166.9,
    fill: "none",
    stroke: "#000",
    strokeDasharray: "5 2 5 5 2 2",
    strokeWidth: 0.3
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 166.9,
    x2: 206.9,
    y1: 166.9,
    y2: 166.9,
    fill: "none",
    stroke: "#000",
    strokeDasharray: "5 2 5 5 2 2",
    strokeWidth: 0.3
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 166.9,
    x2: 166.9,
    y1: 66.9,
    y2: 166.9,
    fill: "none",
    stroke: "#000",
    strokeDasharray: "5 2 5 5 2 2",
    strokeWidth: 0.3
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 166.9,
    x2: 166.9,
    y1: 166.9,
    y2: 206.9,
    fill: "none",
    stroke: "#000",
    strokeDasharray: "5 2 5 5 2 2",
    strokeWidth: 0.3
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 66.9,
    x2: 166.9,
    y1: 206.9,
    y2: 206.9,
    fill: "none",
    stroke: "#000",
    strokeDasharray: "5 2 5 5 2 2",
    strokeWidth: 0.3
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 66.9,
    x2: 66.9,
    y1: 166.9,
    y2: 206.9,
    fill: "none",
    stroke: "#000",
    strokeDasharray: "5 2 5 5 2 2",
    strokeWidth: 0.3
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 66.9,
    x2: 166.9,
    y1: 166.9,
    y2: 166.9,
    fill: "none",
    stroke: "#000",
    strokeDasharray: "5 2 5 5 2 2",
    strokeWidth: 0.3
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 26.900000000000006,
    x2: 66.9,
    y1: 166.9,
    y2: 166.9,
    fill: "none",
    stroke: "#000",
    strokeDasharray: "5 2 5 5 2 2",
    strokeWidth: 0.3
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    x1: 26.900000000000006,
    x2: 26.900000000000006,
    y1: 66.9,
    y2: 166.9,
    fill: "none",
    stroke: "#000",
    strokeDasharray: "5 2 5 5 2 2",
    strokeWidth: 0.3
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    x1: 26.900000000000006,
    x2: 66.9,
    y1: 66.9,
    y2: 66.9,
    fill: "none",
    stroke: "#000",
    strokeDasharray: "5 2 5 5 2 2",
    strokeWidth: 0.3
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    x1: 66.9,
    x2: 66.9,
    y1: 66.9,
    y2: 166.9,
    fill: "none",
    stroke: "#000",
    strokeDasharray: "5 2 5 5 2 2",
    strokeWidth: 0.3
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    x1: 66.9,
    x2: 166.9,
    y1: 10.400000000000006,
    y2: 10.400000000000006,
    stroke: "black",
    strokeWidth: 0.2
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    x1: 166.9,
    x2: 166.9,
    y1: 10.400000000000006,
    y2: 22.000000000000007,
    stroke: "black",
    strokeWidth: 0.2
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    x1: 168.9,
    x2: 183.4,
    y1: 23.900000000000006,
    y2: 23.900000000000006,
    stroke: "black",
    strokeWidth: 0.2
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    x1: 183.4,
    x2: 183.4,
    y1: 23.900000000000006,
    y2: 62.400000000000006,
    stroke: "black",
    strokeWidth: 0.2
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    x1: 172.9,
    x2: 183.4,
    y1: 64.4,
    y2: 62.400000000000006,
    stroke: "black",
    strokeWidth: 0.2
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    x1: 167.4,
    x2: 172.9,
    y1: 66.9,
    y2: 64.4,
    stroke: "black",
    strokeWidth: 0.2
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    x1: 167.4,
    x2: 173.6,
    y1: 66.9,
    y2: 67.9,
    stroke: "black",
    strokeWidth: 0.2
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    x1: 173.6,
    x2: 223.4,
    y1: 67.9,
    y2: 67.9,
    stroke: "black",
    strokeWidth: 0.2
  })), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    x1: 223.4,
    x2: 223.4,
    y1: 67.9,
    y2: 165.9,
    stroke: "black",
    strokeWidth: 0.2
  })), _line26 || (_line26 = /*#__PURE__*/React.createElement("line", {
    x1: 173.5,
    x2: 223.4,
    y1: 165.9,
    y2: 165.9,
    stroke: "black",
    strokeWidth: 0.2
  })), _line27 || (_line27 = /*#__PURE__*/React.createElement("line", {
    x1: 167.5,
    x2: 173.5,
    y1: 166.9,
    y2: 165.9,
    stroke: "black",
    strokeWidth: 0.2
  })), _line28 || (_line28 = /*#__PURE__*/React.createElement("line", {
    x1: 167.5,
    x2: 172.9,
    y1: 166.9,
    y2: 169.4,
    stroke: "black",
    strokeWidth: 0.2
  })), _line29 || (_line29 = /*#__PURE__*/React.createElement("line", {
    x1: 172.9,
    x2: 183.4,
    y1: 169.4,
    y2: 171.4,
    stroke: "black",
    strokeWidth: 0.2
  })), _line30 || (_line30 = /*#__PURE__*/React.createElement("line", {
    x1: 183.4,
    x2: 183.4,
    y1: 171.4,
    y2: 209.9,
    stroke: "black",
    strokeWidth: 0.2
  })), _line31 || (_line31 = /*#__PURE__*/React.createElement("line", {
    x1: 168.9,
    x2: 183.4,
    y1: 209.9,
    y2: 209.9,
    stroke: "black",
    strokeWidth: 0.2
  })), _line32 || (_line32 = /*#__PURE__*/React.createElement("line", {
    x1: 166.9,
    x2: 166.9,
    y1: 211.9,
    y2: 223.4,
    stroke: "black",
    strokeWidth: 0.2
  })), _line33 || (_line33 = /*#__PURE__*/React.createElement("line", {
    x1: 66.9,
    x2: 166.9,
    y1: 223.4,
    y2: 223.4,
    stroke: "black",
    strokeWidth: 0.2
  })), _line34 || (_line34 = /*#__PURE__*/React.createElement("line", {
    x1: 66.9,
    x2: 66.9,
    y1: 211.9,
    y2: 223.4,
    stroke: "black",
    strokeWidth: 0.2
  })), _line35 || (_line35 = /*#__PURE__*/React.createElement("line", {
    x1: 50.400000000000006,
    x2: 64.60000000000001,
    y1: 209.9,
    y2: 209.9,
    stroke: "black",
    strokeWidth: 0.2
  })), _line36 || (_line36 = /*#__PURE__*/React.createElement("line", {
    x1: 50.400000000000006,
    x2: 50.400000000000006,
    y1: 171.4,
    y2: 209.9,
    stroke: "black",
    strokeWidth: 0.2
  })), _line37 || (_line37 = /*#__PURE__*/React.createElement("line", {
    x1: 50.400000000000006,
    x2: 60.900000000000006,
    y1: 171.4,
    y2: 169.4,
    stroke: "black",
    strokeWidth: 0.2
  })), _line38 || (_line38 = /*#__PURE__*/React.createElement("line", {
    x1: 66.4,
    x2: 60.900000000000006,
    y1: 166.9,
    y2: 169.4,
    stroke: "black",
    strokeWidth: 0.2
  })), _line39 || (_line39 = /*#__PURE__*/React.createElement("line", {
    x1: 60.2,
    x2: 66.4,
    y1: 165.9,
    y2: 166.9,
    stroke: "black",
    strokeWidth: 0.2
  })), _line40 || (_line40 = /*#__PURE__*/React.createElement("line", {
    x1: 10.400000000000006,
    x2: 60.2,
    y1: 165.9,
    y2: 165.9,
    stroke: "black",
    strokeWidth: 0.2
  })), _line41 || (_line41 = /*#__PURE__*/React.createElement("line", {
    x1: 10.400000000000006,
    x2: 10.400000000000006,
    y1: 67.9,
    y2: 165.9,
    stroke: "black",
    strokeWidth: 0.2
  })), _line42 || (_line42 = /*#__PURE__*/React.createElement("line", {
    x1: 10.400000000000006,
    x2: 60.2,
    y1: 67.9,
    y2: 67.9,
    stroke: "black",
    strokeWidth: 0.2
  })), _line43 || (_line43 = /*#__PURE__*/React.createElement("line", {
    x1: 66.4,
    x2: 60.2,
    y1: 66.9,
    y2: 67.9,
    stroke: "black",
    strokeWidth: 0.2
  })), _line44 || (_line44 = /*#__PURE__*/React.createElement("line", {
    x1: 60.900000000000006,
    x2: 66.4,
    y1: 64.4,
    y2: 66.9,
    stroke: "black",
    strokeWidth: 0.2
  })), _line45 || (_line45 = /*#__PURE__*/React.createElement("line", {
    x1: 50.400000000000006,
    x2: 60.900000000000006,
    y1: 62.400000000000006,
    y2: 64.4,
    stroke: "black",
    strokeWidth: 0.2
  })), _line46 || (_line46 = /*#__PURE__*/React.createElement("line", {
    x1: 50.400000000000006,
    x2: 50.400000000000006,
    y1: 23.900000000000006,
    y2: 62.400000000000006,
    stroke: "black",
    strokeWidth: 0.2
  })), _line47 || (_line47 = /*#__PURE__*/React.createElement("line", {
    x1: 50.400000000000006,
    x2: 64.9,
    y1: 23.900000000000006,
    y2: 23.900000000000006,
    stroke: "black",
    strokeWidth: 0.2
  })), _line48 || (_line48 = /*#__PURE__*/React.createElement("line", {
    x1: 66.9,
    x2: 66.9,
    y1: 10.400000000000006,
    y2: 21.900000000000006,
    stroke: "black",
    strokeWidth: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "black",
    strokeWidth: 0.2,
    d: "M 64.9 23.900000000000006 Q 66.9 23.900000000000006 66.9 21.900000000000006"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "black",
    strokeWidth: 0.2,
    d: "M 166.9 22.000000000000007 Q 166.9 23.900000000000006 168.9 23.900000000000006"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "black",
    strokeWidth: 0.2,
    d: "M 166.9 211.9 Q 166.9 209.9 168.9 209.9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "black",
    strokeWidth: 0.2,
    d: "M 64.60000000000001 209.9 Q 66.9 209.9 66.9 211.9"
  })), _line49 || (_line49 = /*#__PURE__*/React.createElement("line", {
    x1: 66.9,
    x2: 66.9,
    y1: 161.9,
    y2: 166.9,
    stroke: "black",
    strokeDasharray: "10 10 2 5",
    strokeWidth: 0.2
  })), _line50 || (_line50 = /*#__PURE__*/React.createElement("line", {
    x1: 166.9,
    x2: 166.9,
    y1: 161.9,
    y2: 166.9,
    stroke: "black",
    strokeDasharray: "10 10 2 5",
    strokeWidth: 0.2
  })), _line51 || (_line51 = /*#__PURE__*/React.createElement("line", {
    x1: 66.9,
    x2: 71.9,
    y1: 66.9,
    y2: 66.9,
    stroke: "black",
    strokeDasharray: "10 10 2 5",
    strokeWidth: 0.2
  })), _line52 || (_line52 = /*#__PURE__*/React.createElement("line", {
    x1: 66.9,
    x2: 71.9,
    y1: 166.9,
    y2: 166.9,
    stroke: "black",
    strokeDasharray: "10 10 2 5",
    strokeWidth: 0.2
  })), _line53 || (_line53 = /*#__PURE__*/React.createElement("line", {
    x1: 66.9,
    x2: 66.9,
    y1: 21.900000000000006,
    y2: 26.900000000000006,
    stroke: "black",
    strokeDasharray: "10 10 2 5",
    strokeWidth: 0.2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "width",
    display: "inline"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 66.565926,
    x2: 166.56592,
    y1: 174.92903,
    y2: 174.92903,
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 166.56592,
    x2: 162.56592,
    y1: 174.92903,
    y2: 173.92903,
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 166.56592,
    x2: 162.56592,
    y1: 174.92903,
    y2: 175.92903,
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 66.565926,
    x2: 70.565926,
    y1: 174.92903,
    y2: 173.92903,
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 66.565926,
    x2: 70.565926,
    y1: 174.92903,
    y2: 175.92903,
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 115.42397,
    y: 172.69281,
    fill: "#000",
    fontSize: "5.33330011px",
    textAnchor: "middle"
  }, "\n            Width\n        "))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "depth",
    display: "inline"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 71.900002,
    x2: 71.900002,
    y1: 66.900002,
    y2: 166.89999,
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 71.900002,
    x2: 70.900002,
    y1: 66.900002,
    y2: 70.900002,
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 71.900002,
    x2: 72.900002,
    y1: 66.900002,
    y2: 70.900002,
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 71.900002,
    x2: 70.900002,
    y1: 166.89999,
    y2: 162.89999,
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 71.900002,
    x2: 72.900002,
    y1: 166.89999,
    y2: 162.89999,
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("text", {
    x: -114.55698,
    y: 77.902237,
    fill: "#000",
    fontSize: "5.33330011px",
    textAnchor: "middle",
    transform: "rotate(-90)"
  }, "\n            Depth\n        "))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "height",
    display: "inline"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 71.900002,
    x2: 71.900002,
    y1: 26.9,
    y2: 66.900002,
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 71.900002,
    x2: 70.900002,
    y1: 26.9,
    y2: 30.9,
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 71.900002,
    x2: 72.900002,
    y1: 26.9,
    y2: 30.9,
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 71.900002,
    x2: 70.900002,
    y1: 66.900002,
    y2: 62.900002,
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 71.900002,
    x2: 72.900002,
    y1: 66.900002,
    y2: 62.900002,
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 76.900002,
    y: 48.900002,
    fill: "#000",
    fontSize: "5.33330011px",
    textAnchor: "middle",
    transform: "rotate(-90,76.9,48.9)"
  }, "\n            Height\n        "))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRigidBoxTemplate, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/rigid-box-template.3431c166.svg";
export { ForwardRef as ReactComponent };